export default "__VITE_ASSET__CQwcTSUT__"